import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-dark-bg">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-accent dark:text-dark-muted">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin-only users (no license seat) can only access admin/billing/settings/change-password
  if (user.consumesLicense === false) {
    const path = location.pathname;
    const adminOnlyAllowed =
      path === '/admin' ||
      path.startsWith('/admin/') ||
      path === '/sysadmin' ||
      path.startsWith('/sysadmin/') ||
      path === '/settings' ||
      path === '/change-password' ||
      path === '/login' ||
      path === '/support';
    if (!adminOnlyAllowed) {
      return <Navigate to="/admin" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute; 